module.exports = __webpack_public_path__ + "static/investors-info9-17a68e7ea7f41998d811d7d90e4fc88d.jpg";